type flashTypes = 'notice' | 'alert' | 'error'

export const setFlash = (type: flashTypes, message: string): void => {
  const flashContainer = document.querySelector('#flash')
  const currentFlashMessages = Array.from(flashContainer.querySelectorAll('.flash-message')).map(flash => flash.innerHTML)

  if (!currentFlashMessages.includes(message)) {
    const flash = document.createElement('div')
    flash.className = `flash-message ${type}`
    flash.textContent = message
    flash.setAttribute("data-toast-target", "toast")

    flashContainer.appendChild(flash)
  }
}